import * as React from "react";
import InlineCard from "./InlineCard";
import { useTranslation } from "./i18n";
var Friends = function (props) {
    var gameMode = props.gameMode;
    var _a = useTranslation(), t = _a.t, lang = _a.lang;
    if (gameMode !== "Tractor") {
        return (React.createElement("div", { className: "pending-friends" }, gameMode.FindingFriends.friends.map(function (friend, idx) {
            if (friend.player_id !== null) {
                return null;
            }
            if (friend.card === null ||
                friend.card === undefined ||
                friend.card.length === 0) {
                return null;
            }
            var ordinal = lang === "zh"
                ? String(friend.initial_skip + 1)
                : nth(friend.initial_skip + 1);
            // Render the translated sentence, splitting on the {card} placeholder
            // so we can drop the actual card glyph inline. We deliberately do not
            // pass `card` to t() so the placeholder survives for the split.
            var template = t("friends.intro", { nth: ordinal });
            var _a = template.split("{card}"), before = _a[0], after = _a[1];
            return (React.createElement("p", { key: idx },
                before,
                React.createElement(InlineCard, { card: friend.card }),
                after,
                " ",
                props.showPlayed
                    ? t("friends.played", {
                        n: friend.initial_skip - friend.skip,
                    })
                    : ""));
        })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
function nth(n) {
    var suffix = ["st", "nd", "rd"][(((((n < 0 ? -n : n) + 90) % 100) - 10) % 10) - 1];
    return "".concat(n).concat(suffix !== undefined ? suffix : "th");
}
export default Friends;
